module.exports = __webpack_public_path__ + "img/feedback.3f50a217.svg";